import React from 'react';
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useStore, actions } from "../store";
import { getStepComponentByName } from "../Steps";
import Alert from "../Shared/Alert";

const Wizard = ({ steps }) => {
  const currentStep = useStore(state => state.currentStep)
  const successSteps = useStore(state => state.successSteps)
  const StepComponent = getStepComponentByName(currentStep.name)
  const alert = useStore(state => state.alert)

  return (
    <div>
      <ul className="wizard nav nav-tabs mb-4">
        {steps.map((step, index) =>(
          <li
            key={step.name}
            className={
              cn(
                "nav-item",
                  {
                    active: step.name === currentStep.name,
                    done: step.name !== currentStep.name && successSteps.includes(step.name),
                    last: step.name === 'preview'
                  })
            }
            onClick={() => actions.handleWizardStep(step)}
          >
            <span className="nav-link">
              <em>
                {step.icon ? <i className={step.icon} /> : index + 1}
              </em>
              <span className='fs-4'>{step.title}</span>
            </span>
          </li>
        ))}
      </ul>
      <Alert alert={alert}/>
      <div className="form-wizard-content">
          <div key={currentStep.name} className='tab-pane'>
            <StepComponent stepName={currentStep.name} />
          </div>
      </div>
    </div>
  );
}

Wizard.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })).isRequired,
}

export default Wizard;
